module.exports = __webpack_public_path__ + "static/activepaneicon-63012017bb909a935e08a52d074716d8.png";